import { general } from 'src/config'

export default (value, args) => {
  if (value === undefined || value === null) {
    return false
  }

  return general.locales.map(locale => locale.value).includes(value)
}
